<template>
  <article
    class="SocialCard"
    :class="dataModalId ? 'pointer' : null"
    role="article"
    @click="openModal()"
  >
    <button class="skip-feed" @click.prevent.stop="exitFeed()">
      {{ dataEndFeedLabel }}
    </button>
    <div class="INSTAGRAM"  v-if="isInstagramVariant">
      <div class="insta-header">
        <div class="userame-instapost">
          <slot name="username"></slot>
        </div>
        <p>
          <span v-if="dataCreatedOn">{{ formatteddate }}</span>
        </p>
      </div>
      <div class="postimage flex-fill">
        <slot name="postimage"></slot>
        <template v-if="dataType">
          <img class="ICONS" v-if="dataType == 'carousel'" src="@images/carousel-icon-inst.png" alt="carousel icon">
          <img class="ICONS" v-if="dataType == 'video'" src="@images/reel-icon-inst.png" alt="reel icon">
        </template>
      </div>
      <div class="description  d-flex">
        <div class="username">
          <p class="user p-0 m-0">
            <slot name="username"></slot>
          </p>
        </div>
        <div class="content-wrapper flex-fill">
          <slot name="content"></slot>
        </div>

        <div class="post-footer">
          <p>
            <!--<span v-if="dataCreatedOn">{{ formatteddate }}</span>-->
          </p>
          <a :title="dataExternalSocialButtonTitle" :href="link" target="_blank" rel="noopener">
            <icon :name="socialIconName"></icon>
          </a>
        </div>
      </div>
    </div>
    <div  class="TWITTER" v-else>
      <div class="text-content" :class="{ image: hasPostimage }">
        <figure class="user">
          <div class="square-pic">
            <slot name="profile-pic"></slot>
          </div>
          <figcaption class="user-details">
            <slot name="username"></slot>
          </figcaption>
          <div class="external-link" @click.stop>
            <a :title="dataExternalSocialButtonTitle" :href="link" target="_blank" rel="noopener">
              <icon name="arrow-top-right"></icon>
            </a>
          </div>
        </figure>

        <div class="content flex-fill" :class="{capped: dataTextCapped }">
          <slot name="content"></slot>
        </div>
      </div>

      <div v-if="hasPostimage" class="postimage flex-fill">
        <slot name="postimage"></slot>
      </div>
    </div>


  </article>
</template>

<script>
  import Icon from '@components/atoms/icon'

  export default {
    name: 'SocialCard',
    components: {
      Icon
    },
    props: {
      image: {
        type: Object,
        required: true
      },
      link: {
        type: String,
        required: true
      },
      dataModalId: {
        type: String,
        default: null
      },
      dataCreatedOn: {
        type: String,
        default: null
      },
      dataEndFeedId: {
        type: String,
        default: null
      },
      dataEndFeedLabel: {
        type: String,
        default: null
      },
      dataExternalSocialButtonTitle: {
        type: String,
        default: null
      },
      dataTextCapped: {
        type: Boolean,
        default: null
      },
      dataVariant: {
        type: String,
        validator(value) {
          return ['instagram', 'in/x'].includes(value)
        }
      },
      dataType: {
        type: String,
        default: null
      },
    },
    data() {
      return {
      };
  },
  computed: {
    hasPostimage() {
      return !!(this.$slots['postimage'] || [])[0];
    },
    isInstagramVariant() {
      return this.dataVariant === 'instagram'
    },
    formatteddate() {
      const utcDate = new Date(this.dataCreatedOn);
      return utcDate.getDate() + ' ' + utcDate.toLocaleString('default', { month: 'long' }).substring(0,3);
    },
    socialIconName() {
      if (this.link.includes('linkedin')) return 'linkedin'
      if (this.link.includes('twitter')) return 'twitter'
      if (this.link.includes('instagram')) return 'instagram'
      if (this.link.includes('facebook')) return 'facebook'
    }
  },
  methods: {
    exitFeed() {
      const target = document.getElementById(this.dataEndFeedId);
      if (target) {
        target.setAttribute("tabindex", "-1");
        target.focus();
      }
    },
    openModal() {
      if (this.dataModalId) {
        const modal = document.getElementById(this.dataModalId);
        const modalCloseButton = document.getElementById(this.dataModalId + '-close');
        const header = document.querySelector('.BaseHeader');
        modal.style.display = 'block';
        modalCloseButton.style.display = 'block';
        document.body.style.overflow = 'hidden'
        header.style.display = 'none';
        this.$emit("open-modal",this.dataModalId);
        modal.addEventListener('click', () => {
          document.body.style.overflow = 'visible'
          modal.style.display = 'none';
          header.style.display = 'block';
          modal.removeEventListener('click',null);
          modalCloseButton.style.display = 'none';
          modalCloseButton.removeEventListener('click', null);
        })
        modalCloseButton.addEventListener('click', () => {
          document.body.style.overflow = 'visible'
          modal.style.display = 'none';
          header.style.display = 'block';
          modal.removeEventListener('click', null);
          modalCloseButton.style.display = 'none';
          modalCloseButton.removeEventListener('click', null);
        })
      }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~$scss/_variables";

  .pointer {
    cursor: pointer;
  }

  ::v-deep a {
    color: $color-blue!important;
  }
  .SocialCard {
    position: relative;
    .skip-feed {
      position: absolute;
      left: -99999999px;
      top: 0;
      background-color: white;
      border-radius: 4px;
      border: 0.5px solid;
    }

    .skip-feed:focus {
      left: 0;
    }
  }
  .SocialCard .INSTAGRAM {
    background-color: $color-white;
    min-height: 100%;
    box-sizing: border-box;
    flex-direction: column;
    .insta-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 26px;
    }
    .description {
      flex-direction: column;
    }
    .square-pic {
      position: relative;
      display: inline-block;
      width: 57px;
      height: 57px;
      border-radius: 50%;
      overflow: hidden;

      .pic {
        position: absolute;
        max-width: 100%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .user {
      display: flex;
      align-items: center;
      margin-bottom: 14px;
    }

    .external-link {
      display: block;
      width: 100%;
    }
    .content-wrapper {
      margin-top: 21px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 5; /* number of lines to show */
              line-clamp: 5;
      -webkit-box-orient: vertical;
      @media(min-width:$bootstrap-md){
        margin-top: 26px;
      }
      &.insta {
        -webkit-line-clamp: 4; /* number of lines to show */
                line-clamp: 4;
      }
    }
    .postimage {
      display: block;
      width: 100%;
      height: 0px;
      padding-top: 100%;
      position: relative;
      overflow: hidden;
      img, video {
        width: 100%;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        left: 0;
      }
    }
    .post-footer {
      margin-top: 21px;
      height: 20px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: $color-grey;
      img, video {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }

      .icon {
        color: fade-out($color-grey, 0.25);
        transition: color 0.3s;
        &:hover {
          color: $color-blue;
        }
      }
      p {
        color: $color-grey
      }
    }
    .userame-instapost {
      color: $color-blue;
      display: block;
    }
    .username {
      color: $color-blue;
      margin-top: 18px;
      display: block;
      @media(min-width:$bootstrap-md){
        margin-top: 26px;
      }
      @media(min-width:$bootstrap-lg){
        display: none;
      }
    }

    .ICONS {
      width: 30px!important;
      top: 20px!important;
      right: 5px;
      left: unset!important;
    }
  }
  .SocialCard .TWITTER {
    background-color: $color-white;
    min-height: 100%;
    box-sizing: border-box;
    .text-content {
      padding: 25px;
      border: 1px solid fade-out($color-grey, 0.75);
    }
    .postimage {
      display: block;
      width: 100%;
      height: 0px;
      padding-top: 100%;
      position: relative;
      overflow: hidden;

      img,
      video {
        width: 100%;
        //height: 100%;
        position: absolute;
        //top: 50%;
        left: 0;
        top: 0%;
        //transform: translateY(-50%);
        left: 0;
      }
    }
    .square-pic {
      position: relative;
      display: inline-block;
      width: 57px;
      height: 57px;
      border-radius: 50%;
      overflow: hidden;

      .pic {
        position: absolute;
        max-width: 100%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .user {
      display: flex;
      align-items: center;
      margin-bottom: 14px;
    }
    .user-details {
      margin-left: 15px;

      .name {
        font-size: 16px;
        line-height: 1.2em;
        margin-bottom: 4px;
      }

      .id {
        color: $color-grey;
        font-size: 14px;
        line-height: 1.2em;
      }
    }
    .external-link {
      align-self: flex-start;
      margin-left: auto;
    }
    .content {
      margin-bottom: 14px;
      &.capped {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 5; /* number of lines to show */
              line-clamp: 5;
      -webkit-box-orient: vertical;
      }
    }
    .hashtags {
      display: flex;
      flex-wrap: wrap;
      > * {
        margin-right: .5em;
        color: $color-blue;
      }
    }
  }
  .fullscreen {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 95%;
  }

  .SocialCard.fullscreen {
      ::v-deep .swiper-slide {
        pointer-events: none;
        &.swiper-slide-active {
          pointer-events: auto;
        }
      }
      ::v-deep .swiper-navigation {
        .swiper-button-disabled {
          display: none!important;
        }
      }
      .text-content {
        min-height: 400px;
      }
   }

  .SocialCard.fullscreen .INSTAGRAM {
      display: flex;
      max-width: 1061px;
      width: 100%;
      .insta-header {
        display: none;
      }
      .content-wrapper {
        overflow: auto;
      display: -webkit-box;
      -webkit-line-clamp: unset; /* number of lines to show */
              line-clamp: unset;
      }
      .description {
        padding: 20px 24px;
        width: 100%;
        @media(min-width:$bootstrap-md){
          width: 70%;
        }
        @media(min-width:$bootstrap-lg){
          width: 90%;
        }
      }
      .postimage, .media-wrapper {
        height: auto;
        padding-top: 0;
        position: relative;
        overflow: hidden;
        img, video {
          top: 0;
          width: 100%;
          position: relative;
          transform: none;
        }
      }
      @media(min-width:$bootstrap-md){
        width: 70%;
        flex-direction: row!important;
        .description {
          padding: 40px 24px;
        }
        .postimage {
          max-width: 100%;
          min-width: 300px;

          video {
            display: block;
          }
        }
          .username {
            margin-top: 0;
            @media(min-width:$bootstrap-lg){
              display: block;
            }
          }
      }

    }

.fullscreen .TWITTER {
  display: flex;
  flex-direction: column-reverse!important;
  max-width: 95%;
  .text-content {
    border: none;
  }
  ::v-deep .Carousel {
          height: 100%!important;
  }
  ::v-deep .swiper-container {
          height: 100%!important;
  }
  ::v-deep .postimage,
  ::v-deep .media-wrapper {
    height: auto;
    padding-top: 0;
    position: relative;
    overflow: hidden;

    img,
    video {
            top: 0;
            width: 100%;
            position: relative;
            transform: none;
    }
  }
  ::v-deep .media-wrapper {
    height: 100%;
    background: white;
    img,
      video {
        top: 50%;
        transform: translateY(-50%);
      }
  }
    @media(min-width:$bootstrap-md){
    width: 70%;
    flex-direction: row!important;
      .text-content {
        max-width: 100%;
        border: none;
      }
      ::v-deep .Carousel {
            height: 100%!important;
      }
      ::v-deep .swiper-container {
            height: 100%!important;
      }

    .postimage {
          max-width: 100%;
          min-width: 300px;

      video {
            display: block;
      }
    }
    .text-content {
      width: 100%;
      &.image {
        width: 60%;
      }
    }
    .description {
      padding: 40px 24px;
    }
    .username {
      margin-top: 0;
      @media(min-width:$bootstrap-lg){
        display: block;
      }
    }
  }
}
</style>
